import { CheckCircle2 } from 'lucide-react'

export function Credibility() {
  return (
    <section className="bg-white py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        <div className="flex flex-col items-center text-center">
          <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
            Used in production
          </h2>
          <p className="mb-8 text-lg text-gray-600 dark:text-white/70">
            Garmisch powers StepSkill.
          </p>

          {/* Badge */}
          <div className="inline-flex items-center gap-3 rounded-full border border-[#448AFF]/30 bg-[#448AFF]/10 px-6 py-3">
            <CheckCircle2 className="h-5 w-5 text-[#448AFF]" />
            <span className="font-medium text-gray-900 dark:text-white">
              Used by StepSkill
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}
